import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

import { environment } from 'src/environments/environment';

import { AnalyticsService } from './analytics.service';
import { PageTrackingService } from './page-tracking.service';

export async function initializeAnalytics(): Promise<void> {
  const platformId = inject(PLATFORM_ID);

  if (!isPlatformBrowser(platformId)) {
    return;
  }

  const analyticsService = inject(AnalyticsService);
  const pageTrackingService = inject(PageTrackingService);

  await analyticsService.initialize(environment.analytics);
  pageTrackingService.initialize();
}
